import { render, staticRenderFns } from "./PrintableEdit.vue?vue&type=template&id=24a16499"
import script from "./PrintableEdit.vue?vue&type=script&lang=js"
export * from "./PrintableEdit.vue?vue&type=script&lang=js"
import style0 from "./PrintableEdit.vue?vue&type=style&index=0&id=24a16499&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports